<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBInvoicePositionForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBInvoicePositionList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBInvoicePositionForm from './Form.vue'

export default {
  components: {
    EXSBInvoicePositionForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbinvoiceposition/update/isLoading',
      error: 'exsbinvoiceposition/update/error',
      deleteError: 'exsbinvoiceposition/del/error',
      deleteLoading: 'exsbinvoiceposition/del/isLoading',
      created: 'exsbinvoiceposition/create/created',
      deleted: 'exsbinvoiceposition/del/deleted',
      retrieved: 'exsbinvoiceposition/update/retrieved',
      updated: 'exsbinvoiceposition/update/updated',
      violations: 'exsbinvoiceposition/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBInvoicePositionList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbinvoiceposition/create/reset',
      deleteItem: 'exsbinvoiceposition/del/del',
      delReset: 'exsbinvoiceposition/del/reset',
      retrieve: 'exsbinvoiceposition/update/retrieve',
      updateReset: 'exsbinvoiceposition/update/reset',
      update: 'exsbinvoiceposition/update/update',
      updateRetrieved: 'exsbinvoiceposition/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbinvoiceposition ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
